__turbopack_context__.v({
  "image": "StructuredModuleRenderer-module-scss-module__Qv95HW__image",
  "imageContent": "StructuredModuleRenderer-module-scss-module__Qv95HW__imageContent",
  "structuredContent": "StructuredModuleRenderer-module-scss-module__Qv95HW__structuredContent",
  "text": "StructuredModuleRenderer-module-scss-module__Qv95HW__text",
  "video": "StructuredModuleRenderer-module-scss-module__Qv95HW__video",
});
